import React from 'react';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import { Button, Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import * as yup from 'yup';
const apiUrl = process.env.REACT_APP_API_URL;
const CsvToPdfSchema = yup.object({
  sender: yup.string().email('Invalid email').required('Required'),
  files: yup.array().min(1, 'At least one file is required')
});

const CursiveToPrint = () => {
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (values, actions) => {
    try {
      for (let file of values.files) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('sender', values.sender);


        const response = await fetch(apiUrl, {
          method: 'POST',
          body: formData
        });

        if (!response.ok) throw new Error('Failed to send file');
      }

      enqueueSnackbar('All files sent successfully!', { variant: 'success' });
      actions.resetForm();
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Failed to send files', { variant: 'error' });
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <div style={{
        maxWidth: 400,
        margin: 'auto',
        textAlign: 'center',
        border: '1px solid black',
        backgroundColor: "#f5f5f5",
        borderRadius: 8,
        padding: 10,
        boxShadow: "0px 0px 4px "
      }}>
        <Typography variant="h5">Cursive → Print</Typography>

        <Formik
          initialValues={{ sender: '', files: [] }}
          validationSchema={CsvToPdfSchema}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, values, isSubmitting }) => (
            <Form>
              <div style={{
                textAlign: 'left',
                marginBottom: 15,
                borderRadius: 6,
                padding: 10,
                backgroundColor: 'white'
              }}>
                <Field
                  name="sender"
                  label="Email"
                  component={TextField}
                  fullWidth
                  margin="normal"
                  style={{ padding: 5 }}
                />
              </div>

              <input
                type="file"
                accept="application/pdf"
                multiple
                onChange={(e) => setFieldValue('files', Array.from(e.target.files))}
                style={{ marginTop: 20 }}
              />

              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting || !values.sender || values.files.length === 0}
                style={{ marginTop: 20, width: '100%' }}
              >
                Send Files
              </Button>
              <Button
                type="button"
                variant="contained"
                color="secondary"
                disabled={isSubmitting || !values.sender || values.files.length === 0}
                onClick={() => window.location.reload()}
                style={{ marginTop: 20, width: '100%' }}
              >
                Cancel
              </Button>
            </Form>
          )}
        </Formik>
      </div>

      <hr/>
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <p>This tool takes in a PDF and converts it to an text file.</p>
        <p>If the file is uploaded successfully, a text file will be sent to the entered email address.</p>
        <p>This will take some time. <b>Make sure to check your junk email.</b></p>
      </div>
    </>
  );
};

export default CursiveToPrint;
